const LikeIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3 3.04999C20.15 3.04999 22.5 5.64999 22.5 8.79999C22.5 12.2 19.55 14.3 16.75 16.8C13.95 19.3 12.5 20.65 12 20.95C11.45 20.6 9.65 18.95 7.25 16.8C4.4 14.3 1.5 12.2 1.5 8.79999C1.5 5.64999 3.85 3.04999 6.7 3.04999C8.8 3.04999 9.95 4.04999 10.75 5.19999C11.7 6.49999 11.85 7.14999 12 7.14999C12.15 7.14999 12.3 6.49999 13.25 5.19999C14.05 4.04999 15.2 3.04999 17.3 3.04999V3.04999ZM17.3 1.54999C15.05 1.54999 13.35 2.44999 12 4.34999C10.65 2.49999 8.95 1.59999 6.7 1.59999C3 1.54999 0 4.79999 0 8.79999C0 12.45 2.7 14.8 5.3 17.05C5.6 17.3 5.95 17.6 6.25 17.9L7.4 18.9C9.6 20.85 10.7 21.85 11.2 22.15C11.45 22.3 11.75 22.4 12 22.4C12.3 22.4 12.55 22.3 12.8 22.15C13.3 21.85 14.2 21.05 16.7 18.75L17.7 17.85C18.05 17.55 18.35 17.25 18.7 17C21.35 14.8 24 12.5 24 8.79999C24 4.79999 21 1.54999 17.3 1.54999V1.54999Z"
        fill="#333333"
      />
    </svg>
  );
};

export default LikeIcon;
